// ===============================
// pages/Categories.jsx
// ===============================

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Categories.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
const CATEGORY_API = `${API_BASE_URL}/api/categories`;
const FALLBACK_IMAGE = "https://via.placeholder.com/400x400?text=No+Image";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const resolveImageUrl = (img) => {
    if (!img || String(img).trim() === "") return FALLBACK_IMAGE;

    if (img.startsWith("http://") || img.startsWith("https://")) {
      return img;
    }

    // Handles older local uploads properly
    let cleanPath = img.replace(/^\/?uploads\//, "");
    const baseUrl = API_BASE_URL.endsWith("/") ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
    return `${baseUrl}/uploads/${cleanPath}`;
  };

  const fetchCategories = async () => {
    try {
      setLoading(true);

      const res = await axios.get(CATEGORY_API);

      const rawCategories = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.categories)
        ? res.data.categories
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];

      const activeCategories = rawCategories
        .filter((item) => item && item.name)
        .filter((item) => item.isActive !== false)
        .map((item) => ({
          id: item._id,
          name: item.name,
          slug: item.slug,
          image: resolveImageUrl(item.image),
          description: item.description || "",
        }));

      setCategories(activeCategories);
    } catch (error) {
      console.log("Failed to fetch categories:", error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="categories-page">
      <div className="page-banner desktop-only">
        <h1>Categories</h1>
        <p>Explore products by categories</p>
      </div>

      <div className="container arrivals-grid">
        {loading ? (
          <div className="loading-box">
            <h2>Loading Categories...</h2>
          </div>
        ) : categories.length === 0 ? (
          <div className="loading-box">
            <h2>No categories found.</h2>
          </div>
        ) : (
          categories.map((item) => (
            <div className="arrival-card" key={item.id}>
              <img
                src={item.image}
                alt={item.name}
                onError={(e) => {
                  e.currentTarget.src = FALLBACK_IMAGE;
                }}
              />

              <h3>{item.name}</h3>

              {item.description && <p>{item.description}</p>}

              <Link
                to={`/shop?category=${encodeURIComponent(item.id)}`}
              >
                <button>View Products</button>
              </Link>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Categories;